module.exports = __webpack_public_path__ + "static/media/coummuntiy_left.92f656e2.svg";